module.exports = __webpack_public_path__ + "static/media/stoa_logo.f4d24c34.jpg";